import { render, staticRenderFns } from "./HealthReports.vue?vue&type=template&id=065a931c&scoped=true&"
import script from "./HealthReports.vue?vue&type=script&lang=ts&"
export * from "./HealthReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065a931c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VFadeTransition,VRow,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065a931c')) {
      api.createRecord('065a931c', component.options)
    } else {
      api.reload('065a931c', component.options)
    }
    module.hot.accept("./HealthReports.vue?vue&type=template&id=065a931c&scoped=true&", function () {
      api.rerender('065a931c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/reports/health-reports/views/HealthReports.vue"
export default component.exports